import { combineReducers } from 'redux';
import { reducer as account } from '@/features/account/redux/reducer';

const createRootReducer = () =>
  combineReducers({
    account,
  });

export default createRootReducer;
